import React from "react";
import { Spinner, Row, Col } from "react-bootstrap";

function Busy() {
  return (
    <Row>
      <Col
        className="loader d-flex justify-content-center align-items-center"
        style={{ height: "82vh" }}>
        <Spinner animation="border" variant="dark" />
      </Col>
    </Row>
  );
}

export default Busy;
